<template>
	<div>
		<div
			v-for="t in tags.filter((t) => t.Text.length > 0)"
			:key="t.Text"
			v-tooltip="t.ToolTip"
			class="package-tag"
			:class="{
				'c-package-tag--green': t.Type == 'UnderPriceCap' || t.Type == 'DiscountTag',
				'c-package-tag--orange':
					t.Text == 'Vast tarief' || t.Text == 'Vast actietarief' || t.Type == 'MandatorySmartMeter',
			}"
		>
			{{ t.Text }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'packageTags',
	props: {
		tags: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style>
.package-tag {
	border: 1px solid #d5d5d5;
	display: inline-block;
	padding: 5px 8px;
	border-radius: 8px;
	margin-right: 3px;
	margin-bottom: 4px;
	font-size: 0.85em;
	line-height: 1em;
}
.c-package-tag--green {
	color: #008500;
	border: 1px solid rgb(0, 133, 0);
	background-color: #f1faf1;
}
.c-package-tag--orange {
	color: white;
	border: 1px solid rgb(255, 140, 0);
	background-color: #ffa800;
	font-weight: bold;
}
</style>
